import React from 'react';
import connectToStores from 'alt-utils/lib/connectToStores';
import FileUploadActions from 'actions/files/FileUploadActions';
import FileUploadStore from 'stores/files/FileUploadStore';
import Loading from 'components/pure/utils/Loading';
import NotFound from '@components/not-found';
import {RouterLocation} from '@store/@types/util/ReactRouter';
import {FileUploadId} from 'records/CoachingReviewFileUpload';
import CoachingReviewListeningAssistantContainer from 'components/calls/components/sidebar/listening-assistant/CoachingReviewListeningAssistantContainer';
import CallCardContainer from '@components/call-card/CallCardContainer';
import {CallCardVariant} from '@components/call-card/CallCard.types';
import {getStringQueryParam} from 'utils/getQueryParam';

interface CallCardPageProps {
  location: RouterLocation;
  routeParams: {callId: FileUploadId};
}

interface CallCardPageState {
  loading: boolean;
}

/**
 * Handles route/query params for call card
 */
@connectToStores
export default class CallCardPage extends React.PureComponent<
  CallCardPageProps & ReturnType<typeof CallCardPage.getPropsFromStores>,
  CallCardPageState
> {
  state = {loading: true};

  static getStores() {
    return [FileUploadStore];
  }

  static getPropsFromStores({location, routeParams: {callId}}) {
    const callFromFileuploadStore = FileUploadStore.getState().fileUploadsMap.get(callId);
    const libraryId = getStringQueryParam(location, 'libraryId');

    return {
      call: callFromFileuploadStore,
      callId: callId,
      libraryId,
    };
  }

  async componentDidMount() {
    await FileUploadActions.findFilesById([this.props.callId]);
    this.setState({loading: false});
  }

  render() {
    const {call, libraryId} = this.props;

    if (this.state.loading) return <Loading />;

    if (!call) {
      return (
        <NotFound title="" withHeader={false}>
          Call was not found
        </NotFound>
      );
    }

    return (
      <>
        <CallCardContainer
          callId={call.id}
          location={this.props.location}
          variant={libraryId ? CallCardVariant.LIBRARY : CallCardVariant.DEFAULT}
          libraryId={libraryId}
        />
        <CoachingReviewListeningAssistantContainer
          location={this.props.location}
          callId={call.id}
        />
      </>
    );
  }
}
